import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AppContainer } from 'antd';
import { AuthProvider } from './utils/auth';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AccountsPage from './pages/AccountsPage';
import ClientViewPage from './pages/ClientViewPage';
import WatchlistPage from './pages/WatchlistPage';
import MonitorPage from './pages/MonitorPage';
import GroupPage from './pages/GroupPage';
import MyGroupPage from './pages/MyGroupPage';
import GroupedPositionPage from './pages/GroupedPositionPage';
import GroupedPositionPreviewPage from './pages/GroupedPositionPreviewPage';
import SellProfitPage from './pages/SellProfitPage';
import AutoTradePage from './pages/AutoTradePage';
import DeliveriesQueryPage from './pages/DeliveriesQueryPage';
import TodayOrdersPage from './pages/TodayOrdersPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminRolesPage from './pages/AdminRolesPage';
import SyncLogPage from './pages/SyncLogPage';
import AssetRankPage from './pages/AssetRankPage';
import AiPickPage from './pages/AiPickPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="client-view" element={<ClientViewPage />} />
        <Route path="watchlist" element={<WatchlistPage />} />
        <Route path="monitor" element={<MonitorPage />} />
        <Route path="groups" element={<GroupPage />} />
        <Route path="my-group" element={<MyGroupPage />} />
        <Route path="today-orders" element={<TodayOrdersPage />} />
        <Route path="sell-profit" element={<SellProfitPage />} />
        <Route path="auto-trade" element={<AutoTradePage />} />
        <Route path="deliveries-query" element={<DeliveriesQueryPage />} />
        <Route path="positions-grouped" element={<GroupedPositionPage />} />
        <Route path="positions-grouped-preview" element={<GroupedPositionPreviewPage />} />
        <Route path="admin-users" element={<AdminUsersPage />} />
        <Route path="admin-roles" element={<AdminRolesPage />} />
        <Route path="sync-log" element={<SyncLogPage />} />
      <Route path="asset-rank" element={<AssetRankPage />} />
      <Route path="ai-pick" element={<AiPickPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <HashRouter>
      <ConfigProvider theme={{ token: { colorPrimary: '#c0392b', borderRadius: 6 } }}>
        <AppContainer>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </AppContainer>
      </ConfigProvider>
    </HashRouter>
  );
}
